<template>
  <v-form ref="form" class="">

    <BaseUtil
      ref="util"
      :pageLoading="pageLoading"
    />

    <v-row>
      <v-col cols="12" sm="12" md="12">
        <v-autocomplete
          v-model="entry.itemId"
          v-bind="getObject('itemId')"
          label="Item"
          :items="purchaseItemsList"
          item-value="id"
          item-text="name"
          :search-input.sync="itemsSearch"
          no-filter
          @input="selectItem(true)"
          no-data-text="Nenhum Item encontrado, faça outra busca"
          persistent-hint
          autocomplete="off"
          :disabled="readOnly"
        >
        </v-autocomplete>
      </v-col>     

      <v-col cols="12">
        <v-autocomplete
          :disabled="!entry.itemId || readOnly"
          v-model="entry.packagingId"
          v-bind="getObject('packagingId')"
          label="Embalagem de venda"
          :items="packagingList"
          item-value="id"
          item-text="name"
          @input="selectPackaging"
          :loading="packagingListLoading"
          autocomplete="off"
        >
        </v-autocomplete>
      </v-col>

    </v-row>

  </v-form>
</template>

<script>

import DateField from "@shared_components/date_field.vue";
import ActivitiesIndex from "@models/activities/index.vue";
import ConsumedItemsIndex from "@models/consumed_items/index.vue";
import ProducedProductsIndex from "@models/produced_products/index.vue";
import BaseUtil from "@shared_components/base_util.vue";
import MultiSelect from "@shared_components/multi_select.vue";
import gql from 'graphql-tag';

export default {
  data() {
    return {
      entryAttributes: {},
      addressError: false,      
      
      purchaseItemsList: [],
      purchaseItemsListLoading: false,
      packagingListLoading: false,
      packagingList: [],
      renderComponent: true,
      itemsSearch: "",
      pageLoading: false,
      timer: null,
    };
  },
  props: {
    entry: Object,
    extraData: Object,
    readOnly: {
      type: Boolean,
      default: false
    },
    planningOperation: {
      default: null,
      type: Object
    },
    isEdit: {
      type: Boolean,
      default: false
    },    
    modelNameSingular: {
      type: String,
      default: "Muda"
    },
    modelNamePlural: {
      type: String,
      default: "Mudas"
    },
  },
  components: {
    ActivitiesIndex: ActivitiesIndex,
    DateField: DateField,
    ConsumedItemsIndex: ConsumedItemsIndex,
    ProducedProductsIndex: ProducedProductsIndex,
    BaseUtil: BaseUtil,
    MultiSelect: MultiSelect,
  },
  created() {
    // this.entry = this.entry || new Object;
    this.entryAttributes = this.setupEntryAttributes(this.entry);
  },
  mounted() {
  },
  watch: {
    itemsSearch: function(newSearch, oldSearch) {
      // console.log("newSearch", newSearch, "oldSearch", oldSearch)
      if (this.itemsSearch && this.itemsSearch.length > 0) {
        if ((!this.entry.item || this.entry.item.name != this.itemsSearch) && newSearch.length >= 3) {
          if(this.timer){
            clearTimeout(this.timer);
          }
          this.timer = setTimeout( ()=> {
            // console.log("newSearch", newSearch);
            this.getPurchaseItems();
          }, 1000);
        }
      }
    },
  },
  methods: {

    selectItem: function(clearPackaging, newPackaging=null) {
      this.entry.item = this.purchaseItemsList.find(obj => obj.id == this.entry.itemId);
      // console.log("item, itemID", this.entry.item, this.entry.itemId)
      // this.clearFields();
      if (clearPackaging) {
        this.entry.packagingId = null;
      }
      this.packagingListLoading = true;
      this.$apollo
        .query({
          query: PACKAGINGS_FOR_ITEM_QUERY,
          fetchPolicy: "no-cache",
          variables: {
            itemId: this.entry.itemId
          }
        })
        .then(response => {
          this.packagingList = response.data.accountGlobalSharedContext.allPackagingsOfItem;

          // console.log("this.packagingList",this.packagingList);

          if (newPackaging) {
            let result_find = this.packagingList.find(obj => obj.id == newPackaging.id);
            if (result_find) {
              this.entry.packagingId = newPackaging.id;
              this.entry.packaging = newPackaging;
              // this.selectPackaging();
            } else {
              this.$refs.util.showErrorMessage("A embalagem criada não é compatível com o item selecionado, por isso não irá aparecer na lista de embalagens!");
            }
          } else if (this.packagingList.length == 1 && !this.entry.packagingId) {
            this.entry.packagingId = this.packagingList[0].id;
            this.entry.packaging = this.packagingList.find(obj => obj.id == this.entry.packagingId);
            // this.selectPackage();
          }
        })
        .catch(response => console.log(response))
        .finally(() => (this.packagingListLoading = false));
    },

    selectPackaging: function(){
      this.entry.packaging = this.packagingList.find(obj => obj.id == this.entry.packagingId);
    },
    getPurchaseItems: function() {
      this.purchaseItemsListLoading = true;
      this.$apollo
        .query({
          query: ITEMS_FOR_PURCHASE_QUERY,
          variables: {
            query: this.itemsSearch
          },
          fetchPolicy: "no-cache"
        })
        .then(response => {
          this.purchaseItemsList = response.data.accountGlobalSharedContext.allAvailableItemsForPurchase;
          // console.log("getPurchaseItems", this.purchaseItemsList);
          // if (this.packageList.length == 1 && !this.entry.packageId) {
          //   this.entry.packageId = this.packageList[0].id;
          //   this.selectPackage();
          // }
        })
        .catch(response => console.log(response))
        .finally(() => (this.purchaseItemsListLoading = false));
    },
    getObject: function(element, component) {
      return this.entryAttributes[element];
    },
    isFormValid: function() {
      if (this.$refs.form.validate()) {
        return true;
      } else {
        setTimeout(function(){
          document.querySelector(".v-messages.error--text:first-of-type").scrollIntoView({ behavior: 'smooth', block: 'center' });
        }, 500);
      }
      return false;
    },
    resetFormInputs: function() {
      this.$refs.form.resetValidation();
    }, 
  }
};

const ITEMS_FOR_PURCHASE_QUERY = gql `
  query ($query: String!) {
    accountGlobalSharedContext {
      allAvailableItemsForPurchase(query: $query) {
        id
        name
        unit {
          name
        }
        brand {
          name
        }
        typeText
      }
    }
  }
`;

const PACKAGINGS_FOR_ITEM_QUERY = gql `
  query ($itemId: ID!) {
    accountGlobalSharedContext {
      allPackagingsOfItem(itemId: $itemId) {
        id
        name
        unitName
        size
        text
      }
    }
  }
`;

</script>

<style scoped></style>
